export default __webpack_public_path__ + "static/media/angular.2a97e67d.svg";